function getTaskTitle(task, options) {
  if (!task) {
    return "Opgave";
  }
  if ("type" in task && task.type === "stack") {
    return task.title || (options?.noFallback ? undefined : "Opgavestak");
  }
  if (task?.question?.trim() || options?.noFallback) {
    return task.question;
  }
  switch (task?.taskType) {
    case "WriteAnswers":
      return "Skriv svar";
    case "SelectAnswers":
      switch (task.answerType) {
        case "Checkbox":
        case "DropDown":
          return "Vælg svar";
        case "RadioButton":
          return "Vælg ét svar";
        case "MarkWords":
          return "Markér ord";
        case "MarkCharacters":
          return "Markér tegn";
        case "HyphenateWords":
          return "Del ordet";
        case "PoolCoupon":
          return "Vælg svar";
      }

    // eslint-disable-next-line no-fallthrough
    case "PlaceItems":
      switch (task.answerType) {
        case "InText":
          return "Placér i tekst";
        case "SolidItemsOnImage":
        case "TransparentImagesOnImage":
          return "Placér på billede";
      }

    // eslint-disable-next-line no-fallthrough
    case "Group":
      return "Gruppér";
    case "Match":
      return "Match";
    case "Sequence":
      return "Sæt i rækkefølge";
    case "InfoPage":
      return "Info";
    case "FreeText":
      return "Fritekst";
    case "TextCorrection":
      return "Ret teksten";
    default:
      return "Opgave";
  }
}

export { getTaskTitle };
//# sourceMappingURL=get-task-title.js.map
